import { AnalyticsService } from './app/analytics.service';

export default { AnalyticsService };

window['AmadeusHosResAnalytics'] = Object.freeze({AnalyticsService: AnalyticsService});

